import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Analytics } from '@vercel/analytics/react';
import App from './App.jsx';
// V65.3 — KaTeX stylesheet, imported once app-level so every <MathText>
// span (reference detail rows + RefQuizMode flashcards) is typeset.
import 'katex/dist/katex.min.css';

// ─── Mount the React app ──────────────────────────────────────────
// Providers (outermost to innermost):
//   HelmetProvider — collects per-route <head> tags from <Seo /> components
//   BrowserRouter  — handles client-side routing
//   App            — the actual app
//   <Analytics />  — Vercel Analytics; only sends data when deployed on Vercel,
//                    no-op in local dev. Privacy-friendly: no cookies, no PII.
const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
        <Analytics />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// ─── Register the service worker (PWA) ────────────────────────────
// Only runs in production builds — dev mode skips this so you don't fight
// stale caches while iterating.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // Listen for updates
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('NerdStack: new version available, refresh to update.');
            }
          });
        });
      })
      .catch((err) => console.warn('Service worker registration failed:', err));
  });
}
